import { render } from "./infoGather.vue?vue&type=template&id=3a28bb9e&scoped=true"
import script from "./infoGather.vue?vue&type=script&lang=js"
export * from "./infoGather.vue?vue&type=script&lang=js"

import "./infoGather.vue?vue&type=style&index=0&id=3a28bb9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a28bb9e"]])

export default __exports__